import type { StatsCardProps } from '../types/ui';

const StatsCard = ({ title, value, icon, colorClass = 'primary', className = '' }: StatsCardProps) => {
  const iconNode = typeof icon === 'string'
    ? <i className={`ti ti-${icon}`} />
    : icon;

  return (
    <div className={`card card-sm app-stat-card ${className}`.trim()}>
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-auto">
            <span className={`bg-${colorClass}-lt text-${colorClass} avatar`}>
              {iconNode}
            </span>
          </div>
          <div className="col">
            <div className="font-weight-medium">{value || 0}</div>
            <div className="text-muted">{title}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
